import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useForm, Controller } from "react-hook-form";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { observer } from "mobx-react-lite";
import DocumentTitle from "react-document-title";
import { useStyles } from "../../features/Auth/Auth.styles";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";
import { LoginOptions } from "../../mobx/stores/AuthStore/AuthStore";

interface LoginPageProps {
  onLogin: (loginInfo: LoginOptions) => void;
}

export const LoginPage = observer(({ onLogin }: LoginPageProps) => {
  const classes = useStyles();
  const { loading } = uiStore;
  const { control, handleSubmit } = useForm<LoginOptions>();

  return (
    <DocumentTitle title={"Вход - Mindset.Digital"}>
      <form onSubmit={handleSubmit(handleLoginUser)}>
        <Controller
          render={({ field }) => (
            <TextField
              {...field}
              inputProps={{ "aria-label": "username" }}
              label="E-mail адрес"
              variant="outlined"
              size="small"
              margin={"normal"}
              fullWidth
            />
          )}
          control={control}
          name={"username"}
          defaultValue={localStorage.getItem("username") || ""}
        />
        <Controller
          render={({ field }) => (
            <TextField
              {...field}
              inputProps={{ "aria-label": "password" }}
              label="Пароль"
              variant="outlined"
              type="password"
              size="small"
              margin={"normal"}
              fullWidth
            />
          )}
          control={control}
          name={"password"}
          defaultValue={""}
        />
        <Controller
          name={"rememberMe"}
          control={control}
          defaultValue={JSON.parse(localStorage.getItem("rememberMe") || "false")}
          render={({ field: { onChange, value } }) => {
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value}
                    onChange={(_, checked) => onChange(checked)}
                    color={"primary"}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                }
                label={"Запомнить меня"}
              />
            );
          }}
        />
        <Button
          data-testid={"signin-button"}
          className={classes.submit}
          disabled={loading}
          variant="contained"
          type="submit"
          color="primary"
          size={"medium"}
          fullWidth
        >
          {loading ? <CircularProgress size={24} color={"secondary"} /> : "Вход"}
        </Button>
      </form>
    </DocumentTitle>
  );

  function handleLoginUser(data: LoginOptions) {
    onLogin(data);
  }
});
